import { Directive, effect, ElementRef, inject, input } from '@angular/core';

/**
 * This directive add padding to the host element.
 * The default value is 16px but can be adjusted with a custom value.
 * Usage for custom value: <div lvrPadding="24"></div>
 */
@Directive({
	selector: '[lvrPadding]',
})
export class LvrPaddingDirective {
	private readonly element = inject(ElementRef);

	public readonly padHorizontal = input<number>(16);
	public readonly padVertical = input<number>(16);

	public constructor() {
		effect(() => {
			this.setPadding(this.padHorizontal(), this.padVertical());
		});
	}

	private setPadding(horizontal: number, vertical: number) {
		// Apply padding to the host element
		this.element.nativeElement.style.padding = `${horizontal}px ${vertical}px `;
	}
}
